module.exports = __webpack_public_path__ + "img/monitor-pad.f27d505d.png";